import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import clientReducer from './slices/clientSlice';
import carsReducer from './slices/carsSlice';
import calculatorReducer from './slices/calculatorSlice';
import catalogLeadsReducer from './slices/catalogLeadsSlice';
/**
 * Redux Store конфігурація
 */
export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    clients: clientReducer,
	cars: carsReducer,
	calculator: calculatorReducer,
	catalogLeads: catalogLeadsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
